var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 6.5351C15.875 6.07806 15.4883 5.69135 15.0312 5.69135H8V2.07025C8 1.29681 7.08594 0.945251 6.55859 1.4726L0.371094 7.62494C0.0195312 7.9765 0.0195312 8.50385 0.371094 8.82025L6.55859 15.0078C7.08594 15.5351 8 15.1835 8 14.4101V10.7538H15.0312C15.4883 10.7538 15.875 10.4023 15.875 9.9101V6.5351Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBold);
export default __webpack_public_path__ + "static/media/arrow-left-bold.e4faf7a4aa2586bce3e591c36cab5dfa.svg";
export { ForwardRef as ReactComponent };